import { PosIconProps, SvgWrapper } from './SvgWrapper';

export const CompanionModeEnterIcon = (
  props: Omit<PosIconProps, 'viewBox'>
) => {
  return (
    <SvgWrapper viewBox="0 0 20 20" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 4.5C4 4.22386 4.22386 4 4.5 4H7.85626C8.13241 4 8.35626 3.77614 8.35626 3.5C8.35626 3.22386 8.13241 3 7.85626 3H4.5C3.67157 3 3 3.67157 3 4.5V15.5688C3 16.3972 3.67157 17.0688 4.5 17.0688H15.5688C16.3972 17.0688 17.0688 16.3972 17.0688 15.5688V12.2125C17.0688 11.9364 16.8449 11.7125 16.5688 11.7125C16.2926 11.7125 16.0688 11.9364 16.0688 12.2125V15.5688C16.0688 15.8449 15.8449 16.0688 15.5688 16.0688H4.5C4.22386 16.0688 4 15.8449 4 15.5688V4.5ZM11.3413 3C11.0651 3 10.8413 3.22386 10.8413 3.5C10.8413 3.77614 11.0651 4 11.3413 4H15.4523L11.341 8.11145C11.1709 8.28157 11.1709 8.55739 11.341 8.72752C11.5111 8.89764 11.787 8.89764 11.9571 8.72752L16.0688 4.61562V8.72752C16.0688 9.00366 16.2926 9.22752 16.5688 9.22752C16.8449 9.22752 17.0688 9.00366 17.0688 8.72752V4.5C17.0688 3.67157 16.3972 3 15.5688 3H11.3413Z"
        fill="inherit"
      />
    </SvgWrapper>
  );
};
